import { API_ENDPOINTS } from '@/api/endpoints';
import { Area } from '@/stores/SubprojectStore';
import { apiFetch } from '@/util/apiClient';
import { useQuery } from '@tanstack/react-query';
import { WaterPump, WaterPumpWithMetrics } from '../types';
import { addMetricsToResource } from './techMetrics';

export const useWaterPumpWithMetrics = (conditionedSpaceArea?: Area) => {
  return useQuery<WaterPump[], Error, WaterPumpWithMetrics[]>({
    queryKey: ['waterpump', 'withMetrics', conditionedSpaceArea?.value],
    queryFn: () =>
      apiFetch<WaterPump[]>(API_ENDPOINTS.COMMON.technology.waterpump),
    enabled: conditionedSpaceArea !== undefined,
    select: (data) => addMetricsToResource(data, conditionedSpaceArea),
  });
};
